import type { WorkbookListItem } from '@mathflat/domain/Workbook'
import { tJosa } from '@mathflat/shared/i18n/tJosa'
import { runInAction } from 'mobx'

import { mpEventInfo, TOAST_STR } from '@/constant'
import AssignGroupStudentModal from '@/contentComponents/modal/AssignGroupStudentModal/AssignGroupStudentModal'
import { lessonWorkbookController } from '@/controller/lessonWorkbook.controller'
import { workbookController } from '@/controller/workbook.controller'
import commonRepo from '@/repository/common.repo'
import { RouteName } from '@/router'
import { commonErrorMessage, toastSuccess } from '@/utils/toast'
import { _mixpanelUtils } from '@/utils/trackings/_mixpanel'
import { mixpanelClient } from '@/utils/trackings/mixpanel'
import { trackingConverter } from '@/utils/trackings/utils/trackingConverter'

import modalService from './modal.service'

class CommonWorkbookService {
  // 검정 텍스트를 노출시킬 북코드
  inspect_bookCode: number[] = []

  // async moveEditWorkbook<FixOption extends 'COPY' | 'EDIT'>({
  //   workbookResponse,
  //   entryContext,
  // }: {
  //   workbookResponse: WorkbookListItem
  //   entryContext: MakeLessonMaterialCommonParams<FixOption>['entryContext']
  // }) {
  //   const workbook = workbookResponse.workbook
  //   const {
  //     filter: _filter,
  //     problemIdList,
  //     title,
  //     headtitle,
  //     subtitle,
  //     coverType,
  //     partitionType,
  //     schoolType,
  //     semester,
  //     grade,
  //     revision,
  //     includeAnswerRate,
  //     includeConceptName,
  //     includeLevel,
  //     includeTagTop,
  //   } = await _workbookController.fetchWorkbookDetailInfo(workbook.id)

  //   const schoolSubjectGrade = new SchoolSubjectGrade({ schoolType, semester, grade, revision })
  //   const { autoScored, ...filter } = _filter
  //   let filterId = ''

  //   switch (filter.filterType) {
  //     case 'CONCEPT': {
  //       const { filterType, workbookId, ...restFilter } = filter
  //       filterId = await _workbookController.단원유형필터.makeFilterByConcept({
  //         filterId: null,
  //         makingUnit: filter.makingUnit!,
  //         size: problemIdList.length,
  //         problemIdList,
  //         ...restFilter,
  //         onlyAutoScorable: autoScored,
  //       })
  //       break
  //     }
  //     case 'CORNER': {
  //       const { filterType, workbookId, makingUnit, corners, ...restFilter } = filter
  //       filterId = await _workbookController.단원유형필터.makeFilterByCorner({
  //         filterId: null,
  //         corners: corners as _교재필터.단원유형별필터<'학습단계추가'>['corners'],
  //         size: problemIdList.length,
  //         problemIdList,
  //         ...restFilter,
  //         onlyAutoScorable: autoScored,
  //       })
  //       break
  //     }
  //     case 'CONCEPT_BY_WORKBOOK': {
  //       const { baseWorkbookId, baseWorkbookProblemIds, filterType, ...restFilter } = filter
  //       filterId = await _workbookController.지원교재필터.makeFilterByConceptWorkbook({
  //         ...restFilter,
  //         limitProblemCountPerConcept: null, // TODO: API 수정 후 확인
  //         makingUnit: 'MIDDLE_CHAPTER', // TODO: API 수정 후 확인
  //         workbookId: baseWorkbookId,
  //         exampleProblemIds: [],
  //         workbookProblemIdList: baseWorkbookProblemIds,
  //         onlyAutoScorable: autoScored,
  //       })
  //       break
  //     }
  //     case 'CORNER_BY_WORKBOOK': {
  //       const { baseWorkbookId, baseWorkbookProblemIds, filterType, ...restFilter } = filter
  //       filterId = await _workbookController.지원교재필터.makeFilterByCornerWorkbook({
  //         ...restFilter,
  //         workbookId: baseWorkbookId,
  //         exampleProblemIds: [],
  //         workbookProblemIdList: baseWorkbookProblemIds,
  //         onlyAutoScorable: autoScored,
  //       })
  //       break
  //     }
  //     case 'SCHOOL_TEST': {
  //       const {
  //         workbookId,
  //         basePaperBoxes,
  //         includePracticeTestType,
  //         problemFilterType,
  //         filterType,
  //         ...restFilter
  //       } = filter
  //       filterId = await _workbookController.학교별기출필터.makeFilterBySchoolTest({
  //         ...restFilter,
  //         onlyAutoScorable: autoScored,
  //         maxProblemCount:
  //           problemIdList.length -
  //           (restFilter.practiceTestRound ?? 0) * BySchoolTestService.모의고사_문제수,
  //         pdfOption: {
  //           includeConceptName,
  //           includeAnswerRate,
  //           includeLevel,
  //           includeTagTop,
  //         },
  //       })
  //       break
  //     }
  //   }

  //   // // 수정시에는 workbookId 필수, 복제후 생성에는 Null
  //   const { params } = new MakeLessonMaterialCommonParams<FixOption>({
  //     filterId,
  //     entryContext,
  //   })

  //   const queryString = qs.stringify({
  //     workbookId: workbookResponse.id,
  //     title,
  //     headtitle,
  //     subtitle,
  //     coverType,
  //     partitionType,
  //     gradeLabel: schoolSubjectGrade.gradeSemesterRevisionLabel,
  //     ...('designTemplateId' in workbook && {
  //       designTemplateId: workbook.designTemplateId,
  //     }),
  //   })

  //   // 교재를 만들 당시의 옵션들을 url에 추가
  //   push(`/make-workbook/edit/${params}&${queryString}`)
  // }
  onExitMakeWorkbook = (entryPath?: string) => {
    if (entryPath) {
      commonRepo.router.replace(entryPath)
      return
    } else {
      commonRepo.router.replace(RouteName.academyShareScopeWorkbook)
    }
  }

  // 교재 생성후 이동
  // createWorkbook = (entryPath: string, sameOptionUse = false) => {
  //   // 동일 옵션으로 만들기 시 교재만들기 1단계로 이동 및 sameOptionUse parameter로 보냄
  //   if (sameOptionUse) {
  //     push(`${RouteName._makeCustomWorkbookStep1}?sameOptionUse=USE`)
  //     return
  //   }

  //   switch (entryPath) {
  //     case 'public-workbook':
  //       push(RouteName.publicWorkbook)
  //       break
  //     case 'my-workbook':
  //     default:
  //       push(RouteName.academyShareScopeWorkbook)
  //       break
  //   }
  // }

  openAssignStudentWorkbookModal = ({
    workbookResponse,
    fetchInitCallback,
    title = `교재 ${tJosa('출제')}하기`,
    warningModalContent,
  }: {
    workbookResponse: WorkbookListItem
    fetchInitCallback: (id: WorkbookListItem['id']) => Promise<void>
    title?: string
    warningModalContent?: React.ReactElement
  }): void => {
    const workbook = workbookResponse.workbook
    const assignedList = workbookResponse.list.map(({ studentId, id }) => ({
      studentId,
      studentDataRelationId: id,
    }))

    modalService.openModal(
      <AssignGroupStudentModal
        title={title}
        titleDescription={workbook.title}
        assignedLists={[assignedList]}
        warningModalContent={warningModalContent}
        onSubmit={async (student) => {
          try {
            if (workbook.type === 'PUBLIC') {
              mixpanelClient.track(
                '교재_시중교재_출제완료',
                trackingConverter.getPublicWorkbookSecuringTypeKor(workbook.securingType),
              )
            }

            const studentIds = student.map(({ id }) => id)
            await lessonWorkbookController.assignWorkbookStudent({
              studentIds,
              workbookIds: [workbook.id],
            })
            const academy = commonRepo.academy
            if (academy && academy.academyId) {
              _mixpanelUtils.behaviorTrack(mpEventInfo.교재문제채점, {
                workbookIds: [workbook.id],
                studentIdList: studentIds,
              })
            }

            fetchInitCallback(workbook.id)
            toastSuccess(TOAST_STR.assignWorkbook)
          } catch (error) {
            if (error.status === 400) {
              modalService.openDeletedBookModal()
            } else {
              commonErrorMessage(error)
            }
          }
        }}
        onUnassign={async (newlyAssignedStudentIds) => {
          try {
            await lessonWorkbookController.unAssignStudentWorkbook(newlyAssignedStudentIds)
            fetchInitCallback(workbook.id)
            toastSuccess(TOAST_STR.unassignWorkbook)
            modalService.closeModal()
          } catch (error) {
            if (error.status === 400) {
              modalService.openDeletedBookModal()
            } else {
              commonErrorMessage(error)
            }
          }
        }}
      />,
      {
        onClose: () => {
          fetchInitCallback(workbook.id)
          return true
        },
      },
    )
  }

  checkInspectBook(bookCode: WorkbookListItem['id']) {
    return this.inspect_bookCode.includes(bookCode)
  }

  async fetchInspectBookCode() {
    const data = await workbookController.fetchInspectWorkbookList()
    runInAction(() => {
      this.inspect_bookCode = data
    })
  }
}

export const commonWorkbookService = new CommonWorkbookService()
